module.exports = __webpack_public_path__ + "img/plane-departure.726beb78.svg";